export enum ImportTypeFileExampleEnum {
  allTypes = 'Tout',
  territoires = 'Territoires',
  utilisateurs = 'Utilisateurs',
  secteurs = 'Secteurs',
  profils = 'Profils',
  noComposant = 'Déclaration absence composants',
  deletePatrimoine = 'Suppression patrimoines'
}
